import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-column" }
const _hoisted_2 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_3 = { class: "badge badge-button-range-date rounded-pill font-regular text-body bg-gray-300" }
const _hoisted_4 = { class: "ms-2 text-xs text-body" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center"
}
const _hoisted_6 = { class: "badge badge-button-range-date rounded-pill font-regular text-body bg-transparent p-0 text-end" }
const _hoisted_7 = { class: "ms-2 text-xs text-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("ul", {
  class: "dropdown-menu d-none",
  "aria-labelledby": "date-range-button"
}, null, -1)
const _hoisted_9 = { class: "ranges col-12 col-md-auto" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "border-top"
}
const _hoisted_12 = {
  class: "form-check form-switch ps-0",
  style: {"min-height":"auto"}
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "w-100 p-3"
}
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = { class: "col text-center text-sm" }
const _hoisted_18 = { class: "col text-center text-sm" }
const _hoisted_19 = {
  key: 1,
  class: "w-100 p-3"
}
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "col text-center text-sm" }
const _hoisted_22 = { class: "col text-center text-sm" }
const _hoisted_23 = { class: "col text-center text-sm" }
const _hoisted_24 = { class: "col text-center text-sm" }
const _hoisted_25 = { class: "border-top" }
const _hoisted_26 = { class: "d-flex justify-content-end p-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["disabled", "loading", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangePickerComponent = _resolveComponent("DateRangePickerComponent")!

  return (_ctx.$store.state.datesLoaded)
    ? (_openBlock(), _createBlock(_component_DateRangePickerComponent, {
        key: 0,
        dateRange: _ctx.dateRangeComputed,
        opens: "left",
        onStartSelection: _ctx.selectDate,
        onFinishSelection: _ctx.selectDate,
        onHoverDate: _ctx.hoverDate,
        dateFormat: _ctx.dateFormat,
        showDropdowns: true,
        linkedCalendars: true,
        ranges: _ctx.shortcutsComputed,
        disabled: _ctx.$limitation.datesLimitedAccess()
      }, {
        input: _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-link-secondary-hover btn-sm dropdown d-flex align-items-center text-nowrap h-full", 
					_ctx.compare &&
					_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName')
						? 'py-1'
						: 'py-3'
				]),
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false",
            id: "date-range-button"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.shortcut), 1),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.startDateButton) + " - " + _toDisplayString(_ctx.endDateButton), 1)
              ]),
              (
							_ctx.compare &&
							_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName')
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.shortcutCompare) + ": ", 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.startDateCompareButton) + " - " + _toDisplayString(_ctx.endDateCompareButton), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _hoisted_8
        ]),
        ranges: _withCtx((ranges) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcutsComputed, (range, name) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: name,
                  onClick: ($event: any) => {
							_ctx.selectRange(range, name);
							ranges.clickRange(range);
						},
                  class: _normalizeClass(
							_ctx.shortcut === name && _ctx.shortcutCompare === name
								? 'current-both'
								: _ctx.shortcut === name
								? 'current'
								: _ctx.shortcutCompare === name
								? 'current-compare'
								: ''
						)
                }, _toDisplayString(name), 11, _hoisted_10))
              }), 128))
            ]),
            (_ctx.$route.name === _ctx.$config('RouteConfig', 'ViewRouteName'))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                  _createElementVNode("li", {
                    class: "d-flex justify-content-between",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.compare = true))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Compare'))), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input success ms-0",
                        type: "checkbox",
                        id: "switchCompare",
                        style: {"width":"2em","margin-left":"0","height":"1rem","min-height":"auto"},
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.compare) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.compare]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.compare)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shortcutsCompareComputed, (range, name) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: name,
                      onClick: ($event: any) => (_ctx.selectCompareRange(range, name)),
                      class: _normalizeClass(_ctx.shortcutCompare === name ? 'current-compare' : '')
                    }, _toDisplayString(name), 11, _hoisted_14))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        "calendars-header": _withCtx(() => [
          (!_ctx.compare)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-brand-hover", !_ctx.waitForEnd && !_ctx.waitForCompare ? 'selection' : '']),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setWaits(false, false)))
                    }, _toDisplayString(_ctx.startDateHeader), 3)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-brand-hover", _ctx.waitForEnd && !_ctx.waitForCompare ? 'selection' : '']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setWaits(true, false)))
                    }, _toDisplayString(_ctx.endDateHeader), 3)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-success-hover", !_ctx.waitForEnd && _ctx.waitForCompare ? 'selection-compare' : '']),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setWaits(false, true)))
                    }, _toDisplayString(_ctx.startDateCompareHeader), 3)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-success-hover", _ctx.waitForEnd && _ctx.waitForCompare ? 'selection-compare' : '']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setWaits(true, true)))
                    }, _toDisplayString(_ctx.endDateCompareHeader), 3)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-brand-hover", !_ctx.waitForEnd && !_ctx.waitForCompare ? 'selection' : '']),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setWaits(false, false)))
                    }, _toDisplayString(_ctx.startDateHeader), 3)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btn btn-sm btn-link-brand-hover", _ctx.waitForEnd && !_ctx.waitForCompare ? 'selection' : '']),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setWaits(true, false)))
                    }, _toDisplayString(_ctx.endDateHeader), 3)
                  ])
                ])
              ]))
        ]),
        footer: _withCtx((data) => [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                onClick: ($event: any) => (data.clickCancel()),
                class: "btn btn-sm btn-link-secondary-hover"
              }, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Cancel'))), 9, _hoisted_27),
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-sm text-nowrap ms-1", _ctx.saveButtonDisabled ? 'btn-outline-success' : 'btn-success']),
                ref: "saveButton",
                disabled: _ctx.saveButtonDisabled,
                loading: _ctx.isSubmitting,
                type: "submit",
                onClick: ($event: any) => {
							if (!_ctx.saveButtonDisabled) {
								data.clickApply();
								_ctx.handleSubmit();
							}
						}
              }, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Apply'))), 11, _hoisted_28)
            ])
          ])
        ]),
        _: 1
      }, 8, ["dateRange", "onStartSelection", "onFinishSelection", "onHoverDate", "dateFormat", "ranges", "disabled"]))
    : _createCommentVNode("", true)
}